import './Timer.css';
import {useState} from "react";
import Helper from "../../../services/Helper";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {useActions} from "../../../hooks/useActions";
import {SoundsService} from "../../../services/SoundsService";
import {sounds} from "../../../sounds/sound";

function PlayerTimer() {

    let [timer, setTimer] = useState(null);
    const [secondsPassed, setSecondsPassed] = useState(25);
    const [oneTimeSound, setOneTimeSound] = useState(false);
    const {phase, isPvP, game, playerHand} = useTypedSelector(state => state.game);
    const {endTurn} = useActions()

    const pvpGameTimeOut = 50;

    if (timer === null && phase !== 'enemy_turn' && phase !== 'end_game') {
        setSecondsPassed(pvpGameTimeOut);
        // @ts-ignore
        timer = setInterval(() => {

            setSecondsPassed(sp => sp - 1);

        }, 1000);
        setTimer(timer);
    }

    const minutes = Helper.addLeadingZero(~~(secondsPassed / 60));
    const seconds = Helper.addLeadingZero(secondsPassed % 60);

    if((~~(secondsPassed / 60)) === 0 && (secondsPassed % 60) === 6){
        if(!oneTimeSound) {
            setOneTimeSound(true);
            SoundsService.playSound(sounds.timer_pvp());
        }
    }

    let activeClass = '';
    if (phase !== 'enemy_turn' && phase !== 'end_game' && timer !== null) {
        activeClass = ' playerTimerContainerActive';

        if (secondsPassed < 6) {
            activeClass += ' playerTimerLowTime'
        }

        if (secondsPassed === 0) {
            let handKey: any = null;

            if (Object.keys(playerHand).length > 6) {
                handKey = 6;
            }
            clearInterval(timer);
            setTimer(null);
            setOneTimeSound(false);
            endTurn(handKey);
            if (isPvP || game?.cpu_id === 21) {
                setSecondsPassed(pvpGameTimeOut);
            } else {
                setSecondsPassed(10);
            }
        }

    }

    if (phase === 'enemy_turn' && timer !== null) {
        clearInterval(timer);
        setTimer(null);
    }

    return <div className={'playerTimerContainer font-oswald-bold ' + activeClass}>
        <span>{minutes}</span>:<span>{seconds}</span>
    </div>
}

export default PlayerTimer;